const StickyEl = class {
    constructor(targetEls) {
        this.target = document.querySelectorAll('[data-fixed]');
        this.targetHeights = [];
        this.scrollY = window.scrollY || document.documentElement.scrollTop;
        this.targetEls = (typeof targetEls === 'string') ? document.querySelectorAll(targetEls) : targetEls;
        this.oldIdx = -1;
        document.addEventListener('scroll', _ => this.scrollCheck());
        window.addEventListener('resize', _ => this.scrollCheck());
        this.init();
    }
    init() {
        let scrollY = window.scrollY || document.documentElement.scrollTop;
        let heights = this.target;
        heights.forEach(item => this.targetHeights.push(window.pageYOffset + item.getBoundingClientRect().top));
        if(scrollY > 0) this.scrollCheck();
    }
    scrollCheck() {
        this.scrollY = window.scrollY || document.documentElement.scrollTop;
        let posIdx = 0;
        for(let i=0,max=this.targetHeights.length;i<max;i++) {
            if(this.scrollY > this.targetHeights[posIdx]) {
                posIdx++;
            }
        }
        if(this.oldIdx !== posIdx) {
            this.addClassEvt(posIdx);
            this.oldIdx = posIdx;
        }

    }
    addClassEvt(count) {
        if(count > 0) {
            this.removeClassEvt();
            for(let i=0,max=count;i<max;i++) {
                this.targetEls[i].classList.add('fixed');
            }
        }else if(count === 0) {
            this.removeClassEvt();
        }
    }
    removeClassEvt() {
        this.targetEls.forEach((item,idx) => {
            this.targetEls[idx].classList.remove('fixed');
        });
    }
}
export default StickyEl;
